import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgClass, NgFor } from '@angular/common';

export interface AppPopupData {
  message: string;
  icon: string;
  buttons: PopupButton[];
  type: PopupType;
  submitButtonId?: string;
  textmsg?: string;
}

export interface PopupButton {
  id: string;
  text: string;
}

export enum PopupType {
  ERROR = 'error',
  INFO = 'info',
}

@Component({
  selector: 'app-app-popup',
  standalone: true,
  imports: [NgClass, NgFor],
  templateUrl: './app-popup.component.html',
  styleUrl: './app-popup.component.scss',
})
export class AppPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<AppPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppPopupData
  ) {}

  @HostListener('document:keydown.enter')
  submit() {
    if (this.data.submitButtonId) {
      this.dialogRef.close(this.data.submitButtonId);
    }
  }

  close(buttonId: string) {
    this.dialogRef.close(buttonId);
  }
}
